
export type WordPair = {
  userWord: string;
  aiWord: string;
  aiExplanation?: string;
  proximityScore?: number;
};

export type ProximityLevel = "low" | "medium-low" | "medium" | "medium-high" | "high" | "perfect" | "none";

export const getProximityLevel = (score?: number): ProximityLevel => {
  if (score === undefined) return "none";
  if (score === 100) return "perfect";
  if (score >= 75) return "high";
  if (score >= 50) return "medium-high";
  if (score >= 25) return "medium";
  return "low";
};

export const getProximityColor = (score?: number): string => {
  if (score === undefined) return "hsl(var(--muted-foreground))";
  if (score === 100) return "#0EA5E9"; // blue-500
  if (score >= 75) return "#22c55e"; // green-500
  if (score >= 50) return "#f59e0b"; // amber-500/yellow
  if (score >= 25) return "#f97316"; // orange-500
  return "#ef4444"; // red-500
};

export const getProximityBgColor = (score?: number): string => {
  if (score === undefined) return "bg-muted/60";
  if (score === 100) return "bg-blue-500";
  if (score >= 75) return "bg-green-500";
  if (score >= 50) return "bg-amber-500";
  if (score >= 25) return "bg-orange-500";
  return "bg-red-500";
};
